import axios from "axios";
import schedules from "../../models/grupos/schedules";
import moment from "moment";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getSchedules(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/grphorario/${data}`, { headers })

      .then(({ data }) => {
        return data.map((item) => {
          return schedules.fromJson(item);
        });
      });
  }

  new(items) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      grupoId: items.groupId,
      horarioId: items.schedule,
      fecDesde: items.from + "T00:00:00.000Z",
      fecHasta:
        items.to == null
          ? undefined
          : moment.utc(items.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      segmId: items.segment,
      numSecuencia: items.sequenceNumber,
      segmDespl: parseInt(items.initialDay, 10),
    };
    return axios.post(`${url}/grphorario/grp`, payload, { headers });
  }

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const payload = {
      fecDesde: data.from + "T00:00:00.000Z",
      fecHasta:
        data.to == null
          ? undefined
          : moment.utc(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      segmId: data.segment,
      numSecuencia: data.sequenceNumber,
      segmDespl: parseInt(data.initialDay, 10),
    };

    return axios.patch(
      `${url}/grphorario/${data.groupId}&${data.schedule}&${data.fromOld}`,
      payload,
      { headers }
    );
  }

  delete(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const date = moment.utc(data.from, "DD-MM-YYYY").format("YYYY-MM-DD");

    return axios.delete(
      `${url}/grphorario/${data.groupId}&${data.id}&${date}`,
      { headers }
    );
  }
}
export default service;
